import { coreInitiativesCommentsAddSyncSlice } from './add';
import { CoreInitiativesCommentsName } from './name';
import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postInitiativeComment } from '@api';

export const coreInitiativesCommentsPostAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [ coreInitiativesCommentsAddSyncSlice.syncActionCreator ]
	},
	name: CoreInitiativesCommentsName,
	receive: true,
	request: true,
	requestHandler: postInitiativeComment
});
